import { FaCircleNodes, FaCircleUser, FaEye, FaHashtag, FaNetworkWired, FaPenToSquare, FaServer, FaTrashCan } from "react-icons/fa6";
import { MasterDataStatusBadge } from "../../../../../components/badge/MasterDataStatusBadge";
import { OltSkeletonCard } from "../components/SkeletonCard";
import { OltMobileActionBtn } from "../components/OltMobileActionButton";
import { useNavigate } from "react-router-dom";

export const OltMobileList = ({ data, loading, keyword }) => {
    const navigate = useNavigate();
    return (
        <>
            <section className="lg:hidden space-y-3" aria-label="Daftar Olt">
            {loading && !data && <>{[...Array(4)].map((_, i) => <OltSkeletonCard key={i} />)}</>}

            {!loading && (!data || data?.length === 0) && (
              <div
                className="rounded-2xl p-12 text-center"
                style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
              >
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4"
                  style={{ background: "rgba(51, 65, 85, 0.2)", border: "1px solid rgba(51, 65, 85, 0.2)" }}
                >
                  <FaNetworkWired className="text-2xl text-slate-600" />
                </div>
                <p className="text-slate-400 font-medium">Tidak ada Olt ditemukan</p>
                <p className="text-xs text-slate-500 mt-1">{keyword ? "Coba ubah pencarian" : "Belum ada data OLT"}</p>
              </div>
            )}

            {!loading &&
              data?.map((item) => (
                <article
                  key={item.id}
                  className="rounded-2xl overflow-hidden transition-all duration-200"
                  style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "rgba(0, 180, 216, 0.15)";
                    e.currentTarget.style.background = "rgba(15, 23, 42, 0.7)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "rgba(51, 65, 85, 0.3)";
                    e.currentTarget.style.background = "rgba(15, 23, 42, 0.5)";
                  }}
                >
                  {/* Header */}
                  <div className="p-4 flex items-start gap-3" style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.15)" }}>
                    <div
                      className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{
                        background: "linear-gradient(135deg, rgba(0,180,216,0.15), rgba(0,119,182,0.08))",
                        border: "1px solid rgba(0,180,216,0.15)",
                      }}
                    >
                      <FaNetworkWired className="text-base text-ocean-500" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between gap-2">
                        <h3 className="font-semibold text-gray-100 text-sm truncate">{item.name}</h3>
                        <MasterDataStatusBadge status={item.status} />
                      </div>
                      <p className="font-mono text-xs text-ocean-400/80 bg-ocean-500/8 px-2 py-0.5 rounded-lg border border-ocean-500/10 inline-block w-fit mt-1">
                        Port: {item.port ?? "-"}
                      </p>
                    </div>
                  </div>

                  {/* Stats Grid */}
                  <div className="p-4 grid grid-cols-3 gap-3" style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.15)" }}>
                    {[
                      { icon: FaServer, label: "Port", value: item.port, color: "#48CAE4", bg: "rgba(72,202,228,0.08)", border: "rgba(72,202,228,0.12)" },
                      { icon: FaHashtag, label: "Spliter", value: item.splitter, color: "#fbbf24", bg: "rgba(251,191,36,0.06)", border: "rgba(251,191,36,0.1)" },
                      { icon: FaCircleNodes, label: "ODC", value: item.odc, color: "#a78bfa", bg: "rgba(167,139,250,0.08)", border: "rgba(167,139,250,0.12)" },
                    ].map((stat, i) => {
                      const Icon = stat.icon;
                      return (
                        <div
                          key={i}
                          className="text-center p-2.5 rounded-xl"
                          style={{ background: stat.bg, border: `1px solid ${stat.border}` }}
                        >
                          <Icon className="text-sm mx-auto mb-1" style={{ color: stat.color }} />
                          <p className="text-[10px] text-slate-500 uppercase font-semibold tracking-wider leading-none mb-1">{stat.label}</p>
                          <p className="text-lg font-display font-bold leading-none" style={{ color: stat.color }}>
                            {stat.value ?? "-"}
                          </p>
                        </div>
                      );
                    })}
                  </div>

                  {/* ODP & PPPoE Row */}
                  <div className="px-4 pb-4 grid grid-cols-2 gap-3">
                    <div
                      className="flex items-center gap-2.5 p-3 rounded-xl"
                      style={{ background: "rgba(52, 211, 153, 0.05)", border: "1px solid rgba(52, 211, 153, 0.1)" }}
                    >
                      <FaHashtag className="text-xs text-emerald-400 flex-shrink-0" />
                      <div className="min-w-0">
                        <p className="text-[10px] text-slate-600 uppercase font-semibold tracking-wider leading-none">ODP</p>
                        <p className="text-sm font-bold text-gray-100 mt-0.5">{item.odp ?? 0}</p>
                      </div>
                    </div>
                    <div
                      className="flex items-center gap-2.5 p-3 rounded-xl"
                      style={{ background: "rgba(72, 202, 228, 0.05)", border: "1px solid rgba(72, 202, 228, 0.1)" }}
                    >
                      <FaCircleUser className="text-xs text-ocean-400 flex-shrink-0" />
                      <div className="min-w-0">
                        <p className="text-[10px] text-slate-600 uppercase font-semibold tracking-wider leading-none">User PPoE</p>
                        <p className="text-sm font-bold text-gray-100 mt-0.5">{item.pppoe ?? 0}</p>
                      </div>
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="px-4 py-3 flex justify-end gap-2">
                    <OltMobileActionBtn icon={FaEye} label="Detail" color="#48CAE4" onClick={() => navigate(`/dashboard/master-data/olt/detail/${item.id}`)} />
                    <OltMobileActionBtn icon={FaPenToSquare} label="Edit" color="#a78bfa" />
                    <OltMobileActionBtn icon={FaTrashCan} label="Hapus" color="#f87171" />
                  </div>
                </article>
              ))}
          </section>
        </>
    )
}